import { IconJetpackFilled } from '@tabler/icons-react';

export default function CloseOrden({ onClick, disabled = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="flex items-center justify-center gap-2 border-none rounded-full font-semibold whitespace-nowrap transition-all duration-200 ease-out active:scale-[0.98] hover:brightness-110"
      style={{
        height: '52px',
        padding: '0 28px',
        backgroundColor: '#0071e3',
        color: '#fff',
        fontSize: '15px',
        letterSpacing: '-0.01em',
        fontFamily: '"Public Sans", sans-serif',
        opacity: disabled ? 0.35 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      Confirmar y cobrar
      <IconJetpackFilled size={18} />
    </button>
  );
}
